<script>
  import { mapActions, mapGetters } from 'vuex'
  import CustomerCard from 'components/Customers/CustomerCard.vue'

  // Hardcoded until we find a way to dynamically find the breakpoint value
  const BREAKPOINT = 1200

  export default {
    data () {
      return {
        displayInModal: false,
        mediaQueryList: null
      }
    },

    computed: mapGetters(['selectedCustomer']),

    methods: {
      ...mapActions(['deselectCustomer']),

      checkShouldDisplayInModal (mql) {
        this.displayInModal = !mql.matches
      }
    },

    created () {
      this.mediaQueryList = window.matchMedia(`(min-width: ${BREAKPOINT}px)`)

      // We add a listener on the breakpoint event to reevaluate if card should be displayed in a modal.
      this.mediaQueryList.addListener(this.checkShouldDisplayInModal)
      this.checkShouldDisplayInModal(this.mediaQueryList)
    },

    destroyed () {
      this.mediaQueryList.removeListener(this.checkShouldDisplayInModal)
    },

    beforeRouteLeave (to, from, next) {
      this.deselectCustomer()
        .then(next)
    },

    watch: {
      displayInModal (newVal, oldVal) {
        // If we resize from small to big we prevent displaying inline again,
        // due to a strange bug that the card would then be outside of q-app
        // Todo: Fix above issue
        if (oldVal === true && newVal === false) {
          this.displayInModal = true
        }
      }
    },

    render (h) {
      const customerCardProps = {
        inModal: this.displayInModal,
        customer: this.selectedCustomer
      }
      const customerCard = this.selectedCustomer ? h('customer-card', { props: customerCardProps }) : null

      if (this.displayInModal) {
        return h('q-modal', { props: { value: true, maximized: true } }, [
          customerCard
        ])
      } else {
        return customerCard
      }
    },

    components: {
      CustomerCard
    }
  }
</script>
